export default (function (_ref) {
  var request = _ref.request;
  return {
    /**
       * @description 订单列表
       * @description http://yapi.xiya.vip/project/11/interface/api/75
       */
    MARKET_ADMIN_LOG_ALL: function MARKET_ADMIN_LOG_ALL() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: '/api/market-admin-log/index',
        method: 'post',
        data: query
      });
    },

    /**
       * @description 新闻创建
       * @description http://yapi.xiya.vip/project/11/interface/api/80
       */
    MARKET_ADMIN_LOG_CREATE: function MARKET_ADMIN_LOG_CREATE(data) {
      return request({
        url: '/api/market-admin-log/create',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 字典详情
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_LOG_DETAIL: function MARKET_ADMIN_LOG_DETAIL(id) {
      return request({
        url: '/api/market-admin-log/update',
        method: 'post',
        data: {
          id: id
        }
      });
    },

    /**
       * @description 字典编辑
       * @description http://yapi.xiya.vip/project/11/interface/api/95
       */
    MARKET_ADMIN_LOG_UPDATE: function MARKET_ADMIN_LOG_UPDATE(data) {
      return request({
        url: '/api/market-admin-log/update',
        method: 'put',
        data: data
      });
    },

    /**
       * @description 新闻删除
       * @description http://yapi.xiya.vip/project/11/interface/api/90
       */
    MARKET_ADMIN_LOG_DELETE: function MARKET_ADMIN_LOG_DELETE(id) {
      return request({
        url: '/api/market-admin-log/delete',
        method: 'delete',
        data: {
          id: id
        }
      });
    },
    MARKET_ADMIN_LOG_SYNC: function MARKET_ADMIN_LOG_SYNC(data) {
      return request({
        url: '/api/market-admin-log/sync',
        method: 'post',
        data: data
      });
    }
  };
});